import styled from 'styled-components';
import { Flexbox, Icon } from '@hiiretail/synergy-ui';

export const StyledRetry = styled(Flexbox)<{ size: 'sm' | 'lg' | 'xlg' }>`
  ${({ size }) => {
    if (size === 'lg') {
      return `
          padding: 36px 16px;
          margin: 8px;
          height: calc(100% - 16px);
        `;
    }
    if (size === 'xlg') {
      return `
          padding: 36px 16px;
        `;
    }
  }}
  border-radius: 10px;
`;

export const StyledErrorIconContainer = styled(Flexbox)<{
  size: 'sm' | 'lg' | 'xlg';
}>`
  ${({ size }) =>
    (size === 'sm' || size === 'xlg') &&
    `
      margin-bottom: 16px;
    `}
`;

export const StyledTypographyContainer = styled(Flexbox)<{ size: 'sm' | 'lg' | 'xlg' }>`
  ${({ size }) => (size === 'sm' || size === 'xlg') && 'margin-bottom: 16px;'}
`;

export const StyledRefreshedIcon = styled(Icon.Rotate)`
  font-size: 20px;
`;

export const RetryButtonContainer = styled(Flexbox)`
  width: 100%;
`;
